import React from 'react'
import PageLayout from '../../components/layout/PageLayout'
import UserInfoContainer from '../../features/page/user/UserInfoContainer'
import UserCopyTradingContainer from '../../features/page/user/UserCopyTradingContainer'
import {useSearchParams} from 'react-router-dom'
import UserApiContainer from '../../features/page/user/UserApiContainer'
import useQueryUserDetail from '../../hooks/api/user/useQueryUserDetail'
import UserProContainer from '../../features/page/user/UserProContainer'
import useQueryProDetail from '../../hooks/api/user/useQueryProDetail'
import WalletsTransactionContainer from '../../features/page/wallet/WalletsTransactionContainer'
import UserLeaderKeysContainer from '../../features/page/user/UserLeaderKeysContainer'
import useQueryReward from '../../hooks/api/cashback/useQueryReward'

interface IProps {
    className?: string
}

const UserDetailPage: React.FC<IProps> = ({className}) => {
    const [searchParams] = useSearchParams(document.location.search)
    const userId = searchParams.get('id')
    const {data, refetch} = useQueryUserDetail(userId)
    const {data: proData} = useQueryProDetail(userId)
    const {data: reward} = useQueryReward(userId)

    return (
        <PageLayout
            title={'User Info'}
            className={'grid grid-cols-[auto_450px] space-x-[30px] lg:block lg:space-x-[0px] lg:space-y-[30px]'}>
            <div className={'space-y-[30px]'}>
                <UserInfoContainer data={data} refetch={refetch} />
                {proData?.length > 0 && (
                    <UserProContainer
                        pro={proData
                            ?.sort((a, b) => new Date(b?.end_at)?.getTime() - new Date(a?.end_at)?.getTime())
                            ?.at(0)}
                        data={data}
                    />
                )}
                <UserCopyTradingContainer userId={userId} />
                <UserLeaderKeysContainer userId={userId} />
                <WalletsTransactionContainer userID={userId} />
            </div>
            <div>
                <UserApiContainer data={data} />
            </div>
        </PageLayout>
    )
}

export default UserDetailPage
